import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { Image } from './image';

export class CarStorageDetail {
    constructor(doc) {
		this.label = null;
		this.carStorageAreaMeasure = null;
		this.carStorageAttachmentType = null;
		this.carStorageType = null;
		this.carStorageTypeOtherDescription = null;
		this.improvedSurfaceMaterialType = null;
		this.improvedSurfaceMaterialTypeOtherDescription = null;
		this.parkingSpacesCount = null;
		this.projectParkingSpaceAssignmentType = null;
		this.tenOrMoreParkingSpacesIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.carStorageAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:CarStorageAreaMeasure");
		this.carStorageAttachmentType = x.getStringElement(doc, "./ns:CarStorageAttachmentType");
		this.carStorageType = x.getStringElement(doc, "./ns:CarStorageType");
		this.carStorageTypeOtherDescription = x.getStringElement(doc, "./ns:CarStorageTypeOtherDescription");
		this.improvedSurfaceMaterialType = x.getStringElement(doc, "./ns:ImprovedSurfaceMaterialType");
		this.improvedSurfaceMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:ImprovedSurfaceMaterialTypeOtherDescription");
		this.parkingSpacesCount = x.getIntegerElement(doc, "./ns:ParkingSpacesCount");
		this.projectParkingSpaceAssignmentType = x.getStringElement(doc, "./ns:ProjectParkingSpaceAssignmentType");
		this.tenOrMoreParkingSpacesIndicator = x.getBooleanElement(doc, "./ns:TenOrMoreParkingSpacesIndicator");
   }
}

export class CarStorage {
    constructor(doc) {
		this.label = null;
		this.carStorageDetail = null;
		this.images = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:CAR_STORAGE_DETAIL");
		if (node !== null)
				this.carStorageDetail = new CarStorageDetail(node);
		nodes = x.selectNodes(doc, "./ns:IMAGES/ns:IMAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.images.push(new Image(xn));
			});
		}
   }

	GetCarStorageDetails() {
		var details = this.GetImprovedSurfaceMaterialType();
		details = h.addWithNewline(details, h.toEnumText(this.carStorageDetail.carStorageAttachmentType));
		details = h.addWithNewline(details, this.carStorageDetail.carStorageAreaMeasure.ToString());
		return details;
	}

	GetCarStorageType() {
		return h.descriptionOrOther(this.carStorageDetail.carStorageType, this.carStorageDetail.carStorageTypeOtherDescription);
	}

	GetAssignmentType() {
		return h.descriptionOrOther(this.carStorageDetail.projectParkingSpaceAssignmentType, this.carStorageDetail.projectParkingSpaceAssignmentTypeOtherDescription);
	}

	GetParkingSpacesDetail() {
		var detail = this.carStorageDetail.parkingSpacesCount.toString();
		detail = h.addWithSpacer(detail, this.GetAssignmentType());
		return detail;
	}

	GetImprovedSurfaceMaterialType() {
		return h.descriptionOrOther(this.carStorageDetail.improvedSurfaceMaterialType, this.carStorageDetail.improvedSurfaceMaterialTypeOtherDescription);
	}

}

export class CarStorages {
    constructor(doc) {
			this.label = null;
			this.carStorageList = [];
			var nodes;

			this.label = x.getStringAttribute(doc,"xlink:label");
			nodes = x.selectNodes(doc, "./ns:CAR_STORAGE");
			if (nodes.length > 0)
			{
				nodes.forEach((xn) => {
					this.carStorageList.push(new CarStorage(xn));
				});
			}
	  }

	GetVehicleStorageDetails() {
		var details = "";
		for (var carStorage of this.carStorageList) {
			details = h.addWithSpacer(details, carStorage.GetCarStorageType());
			details = h.addWithSpacer(details, carStorage.GetParkingSpacesDetail());
			details = h.addWithSpacer(details, carStorage.GetImprovedSurfaceMaterialType());
			details = h.addWithSpacer(details, h.toEnumText(carStorage.carStorageDetail.carStorageAttachmentType));
			details = h.addWithSpace(details, carStorage.carStorageDetail.carStorageAreaMeasure.ToString());
		}
		return details;
	}

	GetVehicleStorageSpaces() {
		var details = "";
		for (var carStorage of this.carStorageList) {
			details = h.addWithSpacer(details, carStorage.carStorageDetail.carStorageType, "\n");
			details = h.addWithSpacer(details, carStorage.carStorageDetail.parkingSpacesCount);
		}
		return details;
	}

	GetCarStorageImages() {
		var images = [];
		for (var carStorage of this.carStorageList)
			for (var image of carStorage.images) {
				image.imageSourceCaption = carStorage.GetCarStorageType();
				images.push(image);
			}
		return images;
	}

}

